const config = {
  companyName: "Thurent.com",
  eventLocalStorageKey: "createEventFormSession",
  eventEditLocalStorageKey: "editEventFormSession",
  providerListStorageKey: "providerListSession",
  cartItemKey: "cartItemSession",
  API_BASE_URL_diverted:"https://api.dev.thurent.in/api",
   API_BASE_URL:  "https://api.dev.thurent.in/api",
  INVITATION_URL: "https://dev.thurent.in/invitation",
  // Add other configurations if needed
  token:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEsImlhdCI6MTcyNTU2NTc2MCwiZXhwIjoxNzI1NTY5MzYwfQ.yHdfylPCyDVYm_8aSEpoC_Yc5YOF-z4__diuPB_C1mQ",

  emailAddress: "nick@thurent.com",
  phoneNumber: "+91 74167-34499",
  companyFullName: "THURENT TECH SERVICES PRIVATE LIMITED",
  contactAddress: "T-Hub\nPhase II Gachibowli,\nHYDERABAD Telangana"
};

export default config;
